import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiWoInRitardoWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'wo-in-ritardo-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/work-orders/in-ritardo/count')
      return res.data?.count ?? 0
    },
    staleTime: 30000,
  })
  return (
    <KpiWidget
      title="OdL in ritardo"
      value={data}
      loading={isLoading}
      color={data ? '#ff4d4f' : '#52c41a'}
      onClick={() => navigate('/schede-lavoro?scadute=true')}
    />
  )
}
